import { render, staticRenderFns } from "./RouterView.vue?vue&type=template&id=7c49170b&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RouterView.vue"
export default component.exports